import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import QrCodeIcon from "@mui/icons-material/QrCode";
import { QRCodeSVG } from "qrcode.react";
import { useTheme } from "@mui/material/styles";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";
import GuidanceDialogShell from "../common/GuidanceDialog/GuidanceDialogShell";

export interface ProductItemQRDialogProps {
  open: boolean;
  onClose: () => void;
  itemId: string;
  productName?: string;
}

const ProductItemQRDialog: React.FC<ProductItemQRDialogProps> = ({
  open,
  onClose,
  itemId,
  productName
}) => {
  const { t } = useKivunovaTranslation();
  const theme = useTheme();
  const matchMD = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <GuidanceDialogShell
      open={open}
      onClose={onClose}
      title={t("product-item-detail-qr-code-modal-title", "QR Code")}
      subtitle={t(
        "product-item-qr-dialog-subtitle",
        "Scan this code at checkout to identify the item."
      )}
      icon={<QrCodeIcon sx={{ fontSize: 20 }} />}
      maxWidth="xs"
      dataTestId="product-item-qr-dialog"
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          py: 1
        }}
      >
        <QRCodeSVG value={itemId} size={matchMD ? 180 : 220} />
        <Typography
          variant="body1"
          sx={{
            mt: 2.5,
            fontWeight: 700,
            textAlign: "center",
            wordBreak: "break-all"
          }}
        >
          {itemId}
        </Typography>
        {productName ? (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 0.75, textAlign: "center" }}
          >
            {productName}
          </Typography>
        ) : null}
      </Box>
    </GuidanceDialogShell>
  );
};

export default ProductItemQRDialog;
